"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SpoilerPreferencesResponseDtoTierEnum = void 0;
exports.instanceOfSpoilerPreferencesResponseDto = instanceOfSpoilerPreferencesResponseDto;
exports.SpoilerPreferencesResponseDtoFromJSON = SpoilerPreferencesResponseDtoFromJSON;
exports.SpoilerPreferencesResponseDtoFromJSONTyped = SpoilerPreferencesResponseDtoFromJSONTyped;
exports.SpoilerPreferencesResponseDtoToJSON = SpoilerPreferencesResponseDtoToJSON;
exports.SpoilerPreferencesResponseDtoToJSONTyped = SpoilerPreferencesResponseDtoToJSONTyped;
var TeamsGroupDto_1 = require("./TeamsGroupDto");
var SportItemDto_1 = require("./SportItemDto");
/**
 * @export
 */
exports.SpoilerPreferencesResponseDtoTierEnum = {
    Free: 'free',
    Pro: 'pro',
    Champion: 'champion'
};
/**
 * Check if a given object implements the SpoilerPreferencesResponseDto interface.
 */
function instanceOfSpoilerPreferencesResponseDto(value) {
    if (!('tier' in value) || value['tier'] === undefined)
        return false;
    if (!('global' in value) || value['global'] === undefined)
        return false;
    if (!('sports' in value) || value['sports'] === undefined)
        return false;
    if (!('teams' in value) || value['teams'] === undefined)
        return false;
    return true;
}
function SpoilerPreferencesResponseDtoFromJSON(json) {
    return SpoilerPreferencesResponseDtoFromJSONTyped(json, false);
}
function SpoilerPreferencesResponseDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'tier': json['tier'],
        'global': json['global'],
        'sports': (json['sports'].map(SportItemDto_1.SportItemDtoFromJSON)),
        'teams': (json['teams'].map(TeamsGroupDto_1.TeamsGroupDtoFromJSON)),
    };
}
function SpoilerPreferencesResponseDtoToJSON(json) {
    return SpoilerPreferencesResponseDtoToJSONTyped(json, false);
}
function SpoilerPreferencesResponseDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'tier': value['tier'],
        'global': value['global'],
        'sports': (value['sports'].map(SportItemDto_1.SportItemDtoToJSON)),
        'teams': (value['teams'].map(TeamsGroupDto_1.TeamsGroupDtoToJSON)),
    };
}
